import { IStatisticsSettings } from 'legacy/lut/features/partner360/jbpSettings/models/statisticsSettings'

import { parseRawSetting } from '../helpers/parseRawSetting'
import { IMappedStatisticsSettings } from '../models/parsedStatisticsSettings'

export const mapStatisticsSettings = (rawStatisticsSettings: string): IStatisticsSettings[] => {
  const mappedStatisticsSettings = parseRawSetting<IMappedStatisticsSettings[]>({
    setting: rawStatisticsSettings,
    defaultValue: [],
  })

  return mappedStatisticsSettings.map((it) => ({
    trackId: it.TrackId,
    tracks: it.Tracks,
  }))
}
